import TeamManagement from "../../../../src/courses/partials/team-management/index.mdx";
import * as React from 'react';
export default {
  TeamManagement,
  React
};